














































import {Vue, Component} from 'vue-property-decorator';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import {toI18n} from '@/utils/commonUtils';

@Component({
  components: {
    PageFormSelect
  }
})
export default class UrlDirectDisplay extends Vue {
  public toI18n(needToI18nStr: string): string {
    return toI18n(this.$t('PRODUCT_POP_PRODUCTLIST_' + needToI18nStr));
  }
  private urlDirectDisplayYn = '';

  private get mallProductNos(): string[] {
    return this.$route.params.mallProductNos.split(',');
  }

  private save() {
    if (!this.urlDirectDisplayYn) {
      alert(this.toI18n('PLEASE_ENTER_A_VALUE')); //값을 입력해주세요
      return;
    }

    const params = {
      mallProductNos: String(this.mallProductNos)
    };

    this.$api.patchProducts({params, data: {urlDirectDisplayYn: this.urlDirectDisplayYn}}).then(({data}: any): void => {
      if (data.failures && data.failures.length) {
        return alert(data.failures[0].message);
      }
      alert(this.$t('PRODUCT_PRODUCTLIST_PLM_IT_IS_CHANGED'));
      window.opener.postMessage({urlDirectDisplay: true, data});
      this.close();
    });
  }

  private close() {
    window.close();
  }

  private created() {
    document.body.classList.add('popup');
    window.name = 'batchUrlDirectDisplay';
  }
}
